import { Injectable } from '@angular/core';
import { ApiCurrentCareRecordsServce, CurrentStateInfoType } from './api-call-providers/api-current-care-records.service';
// import { WebSocketService } from './web-socket.service';
import { NurseCallService } from './nurse-call.service';

import * as moment from 'moment/moment';

/*
  Generated class for the CurrentCareRecordsServceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/

// 10秒単位でリフレッシュはしておく
const INTERVAL_TIME = 5 * 1000;

// アプリ起動後何秒以内のアラート情報を表示するか？(3分)
const SHOW_ALERT_TIME = 3 * 60;

@Injectable()
export class CurrentCareRecordsServce {
  alertAudio;

  // 部屋の状態を表示
  // - 表示する部屋のID情報を配列で保持
  roomIndexList = [];
  // - 実際に描画される部屋の状態. hash検索可能な形でデータを保持
  roomInfo: any  = {};

  // アラート関連の情報を保持
  // - 検査用: 重複をチェックするためのもの
  alertIndexList = {};
  // - 表示用: アラートのリスト
  alertList: any = [];

  // 定期的に実行できるように
  timerId: number;

  currentTime;

  constructor(
    public apiCurrentCareRecordsServce: ApiCurrentCareRecordsServce,
    // public webSocketService: WebSocketService,
    public nurseCallService: NurseCallService

  ) {
    this.audioInit();

    // // WebSocketで状態を受信したときの処理
    // // - currentInfoの形式と同じ
    // this.webSocketService.currentInfo$.subscribe((params) => {
    //   console.log('[CurrentCareRecordsServce]', '状態変化を受信', params);

    //   // 部屋IDを元にセット
    //   let roomId = params.room;
    //   if (!this.roomInfo[roomId]) return ;

    //   // 状態を更新する
    //   this.roomInfo[roomId].vitalRR = (params.vitalRR)?params.vitalRR.value:null;
    //   this.roomInfo[roomId].vitalHR = (params.vitalHR)?params.vitalHR.value:null;
    //   this.roomInfo[roomId].state   = (params.state)?params.state.value:null;
    //   this.roomInfo[roomId].envTemperature   = (params.envTemperature)?params.envTemperature.value:null;
    //   this.roomInfo[roomId].envHumidity   = (params.envHumidity)?params.envHumidity.value:null;
    //   this.roomInfo[roomId].envLight   = (params.envLight)?params.envLight.value:null;
    //   this.roomInfo[roomId].envUV   = (params.envUV)?params.envUV.value:null;
    //   this.roomInfo[roomId].envPressure   = (params.envPressure)?params.envPressure.value:null;
    //   this.roomInfo[roomId].envSound   = (params.envSound)?params.envSound.value:null;
    //   this.roomInfo[roomId].envDiscomfort   = (params.envDiscomfort)?params.envDiscomfort.value:null;
    //   this.roomInfo[roomId].envHeatStroke   = (params.envHeatStroke)?params.envHeatStroke.value:null;
    //   this.roomInfo[roomId].envPFU   = (params.envPFU)?params.envPFU.value:null;
    //   this.roomInfo[roomId].envBattery   = (params.envBattery)?params.envBattery.value:null;

    //   this.setCurrentTime();
    // });

    // // WebSocketでアラートを受信したときの処理
    // // - currentInfoの形式と同じ
    // this.webSocketService.alertInfo$.subscribe((params) => {
    //   console.log('WebSocketが受信');
    //   this.receiveAlert(params);
    // });

  }


  /**
   * 画面を初期化する際に呼ばれる処理
   *    - roomIndexList[] に部屋のIDをキーにセットする
   *    - 実際のデータは、 roomInfo{} に部屋のIDをキーに保存する
   */
  async init() {
    // WebSocketのコネクションを念の為貼り直したい
    // this.webSocketService.connect();

    const roomList = await this.getCurrentInfo();
    let currentTime = Math.floor(new Date().getTime() / 1000) - 5;

    this.alertList = [];
    this.alertIndexList = {};
    this.roomIndexList = [];
    this.roomInfo = {};

    roomList.forEach((p) => {
      let roomId = p.rid;

      // 画面描画時にはアラートは表示しない
      // p.alertWatchedTime = currentTime;

      //  Push通知を受けて画面を立ち上げたときに、一定時間以内であればアラート表示しておきたい...
      // if (p.alertTime > (currentTime - SHOW_ALERT_TIME)) {

      //   p.alertWatchedTime = p.alertTime - 1;
      //   p.alertIndex = `${p.roomId}_${p.alertLogId}`;
      //   this.alertIndexList[p.alertIndex] = true;
      //   this.alertList.push(Object.assign({}, p));
      // }
      // 初期セット
      this.setRoomInfo(p);

      this.roomIndexList.push(roomId);
      this.roomIndexList.push(roomId);
      this.roomIndexList.push(roomId);

    });

    // 定期的にAPIを実行する処理を実行
    this.startInterval();
  }


  private receiveAlert(params) {
    console.log('[CurrentCareRecordsServce]', 'アラートを受信', params);
    // 部屋IDを元にセット
    let roomId = params.room;
    let alert = params.alert;

    if (!alert) return ;
    if (!this.roomInfo[roomId]) return ;

    // アラート情報を更新する
    let alertIndex = `${roomId}_${alert.logId}`;
    this.roomInfo[roomId].alertIndex = alertIndex;
    this.roomInfo[roomId].alertType  = alert.type;
    this.roomInfo[roomId].alertState  = alert.state;
    this.roomInfo[roomId].alertTime  = alert.time;
    this.roomInfo[roomId].alertName  = alert.name;

    this.roomInfo[roomId].alertPlace  = alert.place;

    // 複製する
    let alertInfo = Object.assign({}, this.roomInfo[roomId]);

    // 配列に追加
    // 検索用のデータをセット
    this.alertIndexList[alertIndex] = true;


    // アラート情報の表示
    // TODO: alertIndexをキーに上書きする形にしないとダメかも...
    let isNew = true;
    let alertList = this.alertList.map((alert) => {
                      if (alert.alertIndex === alertInfo.alertIndex) {
                        isNew = false;
                        return alertInfo;
                      }

                      // // 履歴テーブルのデータに更新がある場合はここでも定義する
                      // // - 見つかった場合は、stateを変更する
                      // if (params.nurseCallList) {
                      //   let target = params.nurseCallList.find((_a => {
                      //                 let alertIndex = `${roomId}_${_a.logId}`;
                      //                 return alertIndex === alert.alertIndex;
                      //               }));
                      //   if (target) {
                      //     alert.alertState  = target.state;
                      //   }
                      // }
                      return alert;
                    });
    if (isNew) {
      alertList = [...[alertInfo], ...this.alertList];
    }
    this.alertList = alertList;


    // ナースコールかつ開始以外のステータスでは、音は鳴らさない
    if (alert.type === 'nurseCall' && alert.state !== 'START') {
      this.audioStop();
    } else {
      // アラートの音を再生する
      this.audioStart();
    }
    this.setCurrentTime();
  }

  // **************************************
  // * アラート音 初期化
  // **************************************
  audioInit() {

    if (this.alertAudio) {
      this.alertAudio.removeEventListener("ended", this.onEndedAudioEvent, false);
      this.alertAudio = null;
    }

    this.alertAudio = new Audio();
    //プリロード
    this.alertAudio.preload = "auto";
    //音のバスを指定
    this.alertAudio.src = "./assets/sound/phoneRinging.mp3";
    this.alertAudio.load();
    this.alertAudio.addEventListener("ended", this.onEndedAudioEvent, false);
  }

  private onEndedAudioEvent() {
    if (this.alertAudio) {
      this.alertAudio.currentTime = 0;
      this.alertAudio.play();
    }
  }


  /**
   * アラート音 再生
   */
  audioStart() {
    if (this.alertAudio.paused) {
      this.alertAudio.currentTime = 0;
      this.alertAudio.play();
    }
  }

  /**
   * アラート音 停止
   */
  audioStop() {
    if (!this.alertAudio.paused) {
      this.alertAudio.currentTime = 0;
      this.alertAudio.pause();
    }
  }

  setRoomInfo(params: CurrentStateInfoType) {
    let roomId = params.rid;
    let patientId = "";
    let patientName = "";
    let gender = "MAN";
    if (params.careReceiver) {
      patientId = params.careReceiver.code;
      patientName = params.careReceiver.name;
      gender = params.careReceiver.gender;
    }

    let alertIndex = "";
    let alertWatchedTime = 0;
    if (params.alert) {
      alertIndex = params.rid + '_' + params.alert.time;
      alertWatchedTime = params.alert.time;
    }

    this.roomInfo[roomId] = {
      roomId: params.rid,
      patientId: patientId,

      // 表示項目
      roomName: params.rname,
      patientName: patientName,
      patientIcon: "",
      gender: gender,

      // バイタル精査
      vitalBT: params.vbt ? params.vbt.v : null,
      vitalBPH: params.vbph ? params.vbph.v : null,
      vitalBPL: params.vbpl ? params.vbpl.v : null,
      vitalRR: params.vrr ? params.vrr.v : null,
      vitalHR: params.vhb ? params.vhb.v : null,

      state: params.state ? params.state.v : "",
      time: params.time,

      // アラートの情報
      alertWatchedTime: alertWatchedTime,
      alertType : null, // params.alertType,
      alertLogId: null, //  params.alertLogId,
      alertState: null, //  params.alertState,
      alertTime: null, // params.alertTime,
      alertName: null, // params.alertName,
      alertPlace: null, // params.alertPlace,
      alertIndex: alertIndex,

      // 環境センサー
      envTemperature: params.et ? params.et.v : null,
      envHumidity: params.eh ? params.eh.v : null,
      envLight: params.el ? params.el.v : null,
      envUV: null,
      envPressure: params.ep ? params.ep.v : null,
      envSound: params.es ? params.es.v : null,
      envDiscomfort: null,
      envHeatStroke: null,
      envPFU: null,
      envBattery: null,
      sensorDoor: true,
    };
    return this.roomInfo[roomId];
  }

  // **************************************
  // * アラート関連の処理
  // **************************************


  /**
   * アラート情報をリストから削除するときの処理
   *
   * @params alertInfo : currentRoomInfoの形式
   */
  removeAlert(alertInfo) {
    // 検索用
    delete this.alertIndexList[alertInfo.alertIndex];
    // 表示用
    this.alertList = this.alertList.filter(a => a.alertIndex !== alertInfo.alertIndex);
  }


  // **************************************
  // * 部屋の状態表示
  // **************************************

  /**
   * APIで最新の状態を取得する
   */
  currentInfo: any;
  async getCurrentInfo(): Promise<CurrentStateInfoType[]> {
    const viewerId = 300;
    this.currentInfo = null;
    // { status: 0, msg: "OK", data: []{}}}
    let result = await this.apiCurrentCareRecordsServce.getCurrentInfo(viewerId);
    this.setCurrentTime();

    if (!result || !result.data) return [];
    this.currentInfo = {
      info: result.data,
      alert: []
    };
    return result.data;
  }

  async setAlertInfo() {
    // アラート表示用
    this.alertList = [];
    // APIで受信したアラート情報をセットする
    this.alertList = this.currentInfo.alert;
    // TODO: バツボタンを押しているアラート情報は表示しない！？
    // TODO: 閲覧状況を並び替える？
  }



  async startInterval() {
    // 定期取得処理開始
    if (this.timerId) clearInterval(this.timerId);
    this.timerId = setInterval(() => {
                      this.setData();
                    }, INTERVAL_TIME);
    let isFirstView = true;
    await this.setData(isFirstView);
    // await this.getAlertLog();
  }

  //   // アラートの履歴は、初回のみ取得
  // async getAlertLog() {
  //   let currentTime = Math.floor(new Date().getTime()/1000);


  //   let mStart = moment().subtract(15, 'minutes');
  //   let mEnd = moment();
  //   let query:any = {
  //     startDate: mStart.format('YYYY-MM-DD'),
  //     startTime: mStart.format('HH:mm'),
  //     endDate: mEnd.format('YYYY-MM-DD'),
  //     endTime: mEnd.format('HH:mm'),
  //     unlimited: "unlimited"
  //   }
  //   let res = await this.nurseCallService.getCallLogs(query).catch(e => null);
  //   if (res && res.data) {
  //     console.log('ナースコールの直近のアラートログ')
  //     let alertLogs = res.data.map(log => {
  //       let alertIndex = `${log.room}_${log.logId}`;

  //       return {
  //         roomId: log.room,
  //         patientId: "5e71e2b280142907c20618f0",
  //         roomName: "101号室",
  //         patientName: "山田 太郎",
  //         patientIcon: "",
  //         // Push通知などでアラート受信中は、定期取得データの処理は反映しないようにしておく
  //         alertIndex: alertIndex,
  //         alertType: 'nurseCall',
  //         alertState: log.state,
  //         alertTime: log.time,
  //         alertName: log.callTypeName,
  //         alertPlace: log.roomName,
  //       }
  //     }).filter(a => {
  //       // 15分以上残っているデータは削除する
  //       if ((a.alertTime + 60*15) < currentTime) {
  //         return false;
  //       }
  //       return true;
  //     });
  //     console.log(alertLogs);
  //     this.alertList = alertLogs;
  //   }

  // }


  stopInterval() {
    if (this.timerId) clearInterval(this.timerId);
  }



  async setData(isFirstView: boolean = false) {
    let currentTime = Math.floor(new Date().getTime()/1000);

    let isAutoStopAlert = true;
    // 現在の状態を反映しておく(表示ずれが無いように)
    let roomList = await this.getCurrentInfo();
    console.log(roomList);
    roomList.forEach(p => {
      let roomId = p.rid;
      if (!this.roomInfo[roomId]) return;
      this.roomInfo[roomId].vitalBT = p.vbt ? p.vbt.v : null;
      this.roomInfo[roomId].vitalBPH = p.vbph ? p.vbph.v : 120;
      this.roomInfo[roomId].vitalBPL = p.vbpl ? p.vbpl.v : 80;
      this.roomInfo[roomId].vitalRR = p.vrr ? p.vrr.v : null;
      this.roomInfo[roomId].vitalHR = p.vhb ? p.vhb.v : null;
      this.roomInfo[roomId].state = p.state ? p.state.v : ""; // p.state;

      // Push通知などでアラート受信中は、定期取得データの処理は反映しないようにしておく
      this.roomInfo[roomId].alertLogId = null; // p.alertLogId;
      this.roomInfo[roomId].alertType = null; // p.alertType;
      this.roomInfo[roomId].alertState = null; //  p.alertState;
      this.roomInfo[roomId].alertTime = null; // p.alertTime;
      this.roomInfo[roomId].alertName = null; // p.alertName;
      this.roomInfo[roomId].alertPlace = null; // p.alertPlace;

      this.roomInfo[roomId].envTemperature = p.et ? p.et.v : null;
      this.roomInfo[roomId].envHumidity = p.eh ? p.eh.v : null;
      this.roomInfo[roomId].envLight = p.el ? p.el.v : null;
      this.roomInfo[roomId].envUV = null; // p.envUV;
      this.roomInfo[roomId].envPressure = p.ep ? p.ep.v : null;
      this.roomInfo[roomId].envSound = p.es ? p.es.v : null;

      this.roomInfo[roomId].envDiscomfort = null; // p.envDiscomfort;
      this.roomInfo[roomId].envHeatStroke = null; // p.envHeatStroke;
      this.roomInfo[roomId].envPFU = null; // p.envPFU;
      this.roomInfo[roomId].envBattery = null; // p.envBattery;
      this.roomInfo[roomId].sensorDoor = true; // p.envBattery;



      // // アラートが存在するかを確認する
      // if (this.roomInfo[roomId].alertTime > this.roomInfo[roomId].alertWatchedTime) {
      //   let currentRoomInfo = this.roomInfo[roomId];
      //   let alertIndex = `${currentRoomInfo.roomId}_${currentRoomInfo.alertTime}`;
      //   // 既に表示中の場合は何もしない
      //   if (!this.alertIndexList[alertIndex]) {
      //     this.alertIndexList[alertIndex] = true;
      //     alertList.push(Object.assign({}, currentRoomInfo, {alertIndex}));

      //     this.roomInfo[roomId].alertIndex = alertIndex;

      //   } else {

          // 既に表示中のアラートで閉じていないアラートがある場合
          // 既に一定時間経過している場合は、閲覧したことにする
          if (this.roomInfo[roomId].alertTime + SHOW_ALERT_TIME < currentTime) {
            this.roomInfo[roomId].alertWatchedTime = currentTime;
          }

          // 1件でも、画面にアラートが表示されている場合は、音を止めない
          if (this.roomInfo[roomId].alertWatchedTime < this.roomInfo[roomId].alertTime) {
            isAutoStopAlert = false;
          }
      //   }
      // }
    });

    // アラートの精査
    console.log('アラート情報');
    console.log(this.alertList);
    this.alertList = this.alertList.filter(a => {
                      // 10分以上残っているデータは削除する
                      if ((a.alertTime + 10*60) < currentTime) {
                        return false;
                      }
                      return true;
                    }).map(a => {
                      // 3分以上 RECOVERY になっていない場合は、通信エラーの可能性がある
                      if (a.alertState !== 'RECOVERY' && ((a.alertTime + 3*60) < currentTime)) {
                        a.alertState = 'ERROR';
                        console.log(a);
                        return a;
                      }
                      return a;
                    })

    // // アラート発生
    // if (alertList.length > 0) {
    //   this.alertList = [...alertList, ...this.alertList];

    //   // 停止中の場合は再生する
    //   this.audioStart();

    // // 新しいアラートがない & 停止すべきサラートがある
    // } else if (isAutoStopAlert) {
    //   // 再生中の場合は停止する
    //   this.audioStop();
    // }

    // if (isAutoStopAlert) {
    //   this.audioStop();
    // }
  }


  /**
   * メイン画面に描画しているアラートレイヤーを削除する
   */
  closeAlertLayer(roomId, alertIndex = null) {
    // アラートの音は停止させる
    this.audioStop();

    let isStopAlert = false;
    if (alertIndex) {
      if (this.roomInfo[roomId].alertIndex === alertIndex) {
        isStopAlert = true;
      }
    } else {
      isStopAlert = true;
    }

    if (isStopAlert) {
      // 閲覧リストをセット
      let alertWatchedTime = Math.floor(new Date().getTime()/1000);
      this.roomInfo[roomId].alertWatchedTime = alertWatchedTime;
    }

    if (!alertIndex) {
      alertIndex = this.roomInfo[roomId].alertIndex;
    }
    if (alertIndex) {
      let alertInfo = this.alertList.find(a => a.alertIndex === alertIndex);
      if (alertInfo) {
        this.removeAlert(alertInfo);
      }
    }
  }

  setCurrentTime(timestamp: number = 0) {
    if (timestamp) {
      this.currentTime = moment.unix(timestamp).format('HH:mm:ss');
    } else {
      this.currentTime = moment().format('HH:mm:ss');
    }
  }

}



// WEBPACK FOOTER //
// ./src/providers/current-care-records.servce.ts